
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { Settings } from "../constant";
@Component
export default class MapPreview extends Vue {
  $overlay!: any;
  $refs!: any;
  $gmap!: any;
  $elmnt!: HTMLElement;
  // private mapDefaultZoom = Settings.MAP_DEFAULT_SVG_SCALE;
  @Prop() private svgUrl!: string;
  @Prop() private NECornerLatitude!: number;
  @Prop() private NECornerLongitude!: number;
  @Prop() private CenterpointLatitude!: number;
  @Prop() private CenterpointLongitude!: number;
  @Prop() private SWCornerLatitude!: number;
  @Prop() private SWCornerLongitude!: number;
  @Prop() private mapZoom!: number;
  
  private zoomLevel = this.mapZoom;

  @Watch('zoomLevel') changeInZoomLevelFromComponent() {
    if (this.zoomLevel >= 10 && this.zoomLevel <= 20) {
      this.changeZoomLevel(this.zoomLevel);
    }
  }

  @Emit('changeZoomLevel') changeZoomLevel(zoomLevel: number) {}
  mounted() {
    const svgContainer = this.mapSvgContainer();
    this.$refs.mapRef.$mapPromise.then(() => {
      let VueOverlay = function (bounds: any, options: any) {
        this.$el = svgContainer;
        this.$bounds = bounds;
        this.$centered = options.centered;
      };
      VueOverlay.prototype = new window.google.maps.OverlayView();
      VueOverlay.prototype.constructor = VueOverlay;
      VueOverlay.prototype.onAdd = function () {
        this.$el.style.position = "absolute";
        let panes = this.getPanes();
        panes.overlayMouseTarget.appendChild(this.$el);
      };

      VueOverlay.prototype.onRemove = function () {
        this.$el.parentNode.removeChild(this.$el);
      };

      VueOverlay.prototype.draw = function () {
        let overlayProjection = this.getProjection();
        let sw = overlayProjection.fromLatLngToDivPixel(
          this.$bounds.getSouthWest()
        );
        let ne = overlayProjection.fromLatLngToDivPixel(
          this.$bounds.getNorthEast()
        );
        let div = this.$el;
        div.style.left = sw.x + "px";
        div.style.top = ne.y + "px";
        div.style.width = ne.x - sw.x + "px";
        div.style.height = sw.y - ne.y + "px";
      };

      const mapElement: HTMLElement = document.getElementById(
        "map"
      ) as HTMLElement;
      this.$gmap = new window.google.maps.Map(mapElement, {
        zoom: this.mapZoom,
        minZoom: Settings.MAP_MIN_SVG_SCALE,
        maxZoom: Settings.MAP_MAX_SVG_SCALE,
        center: {
          lat: +this.CenterpointLatitude,
          lng: +this.CenterpointLongitude,
        },
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        clickableIcons: false,
      });
      const bounds = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(
          this.SWCornerLatitude,
          this.SWCornerLongitude
        ),
        new window.google.maps.LatLng(
          this.NECornerLatitude,
          this.NECornerLongitude
        )
      );
      this.$overlay = new VueOverlay(bounds, {
        centered: true,
        layer: "overlayLayer",
      });
      this.$overlay.setMap(this.$gmap);
      mapElement.addEventListener("mousewheel", (e) => {
        this.zoomLevel = this.$gmap.zoom;
      });
    });
  }

  mapSvgContainer() {
    let div = document.createElement("div");
    div.style.borderStyle = "none";
    div.style.borderWidth = "0px";
    div.style.position = "absolute";
    let img = document.createElement("img");
    img.src = this.svgUrl;
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.opacity = "1";
    img.style.position = "absolute";
    div.appendChild(img);
    return div;
  }

  svgZoom(zoomLevel: number) {
    this.$gmap.setZoom(zoomLevel);
  }

  svgZoomIn() {
    const { zoom } = this.$gmap;
    let newZoom = zoom + 1;
    this.$gmap.setZoom(newZoom);
    this.zoomLevel = newZoom;
  }

  svgZoomOut() {
    const { zoom } = this.$gmap;
    let newZoom = zoom - 1;
    this.$gmap.setZoom(newZoom);
    this.zoomLevel = newZoom;
  }

  changeZoomHandler() {
    this.zoomLevel = 10;
  }
}
